import { Card, Col , Row, Container} from 'react-bootstrap';
import React from 'react'
import { shop } from '../../data/shop';
import '../../styles/Shop.css';

export const Shop = () => {
  return (
    <>
    <Container >
      <Row>
        {
            shop.map(item => (
                <Col sm key={item.id} className="card-columns animate__animated animate__fadeIn">  
                <Card style={{ width: '25rem' }}>  
                <a href={item.Link} target="_blank" rel="noopener noreferrer">
                    <Card.Img  variant="top" src={ "./assets/shop/"+item.id+".jpg" } />  
                </a> 
                <Card.Body>
                    <Card.Text style={{textAlign: "center"}}>
                        { item.Name }
                    </Card.Text>
                </Card.Body>
                </Card>
                </Col>
            ))
       }
      </Row>
    </Container>
    </>
  )
}
